import { useOperations } from '@frontend/hooks';

import { InstanceOperationsName } from '../types/user';

import AccessDenied from './AccessDenied';

/**
 * Component to check if instance has at least one of the required capabilities enabled to access the children components.
 * @param capabilities - list of capabilities of which at least one is required to access the children (checked using Logical OR)
 * @param children - children components to render if instance has capabilities
 * @returns JSX.Element - children components if instance has capabilities, otherwise shows Access Denied page
 */
function CanInstance({
  capabilities,
  children,
}: {
  capabilities: InstanceOperationsName[];
  children: JSX.Element;
}) {
  const { canInstance } = useOperations();

  if (!canInstance(capabilities)) {
    return <AccessDenied />;
  }

  return children;
}

export default CanInstance;
